import React from 'react';
import './Circle.scss';

export default function Circle() {
  return (
    <div className="circle">
      <div className="circle-point"></div>
    </div>
  )
}
